import {
    ChangeDetectionStrategy,
    Component,
    computed,
    effect,
    inject,
    input,
    model,
    output,
    viewChild,
} from '@angular/core';

import { SearchComponent } from '@connect-services/client/components/search/search.component';
import { PanelService } from '@connect-services/client/services/panel.service';
import { PaginatorComponent } from '@connect-services/src/lib/components/paginator/paginator.component';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { PaginationParameters } from '@shared/client/models/pagination.model';

export enum Alignment {
    COLUMN = 'column',
    ROW = 'row',
}

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PaginatorComponent, RessourcesModule, SearchComponent],
    selector: 'app-pagination-footer-template',
    templateUrl: './pagination-footer-template.component.html',
})
export class PaginationFooterTemplateComponent {
    public readonly canSearch = input<boolean>(true);
    public readonly forceAlignment = input<Alignment | undefined>();
    public readonly forceReset = model<boolean>(false);
    public handleSearch = output<string>();
    public onPageChange = output<number>();
    public readonly paginationParameters = input.required<PaginationParameters>();
    public paginator = output<PaginatorComponent>();
    public readonly searchDisabled = input.required<boolean>();
    public readonly selectedEntitiesNumber = input<number>();
    public readonly selectedLayerNumber = input<number>();
    public readonly totalEntities = input<number>();

    protected readonly isFlexCol = computed<boolean>(() => {
        const alignment = this.forceAlignment();

        switch (alignment) {
            case Alignment.COLUMN:
                return true;
            case Alignment.ROW:
                return false;
            default:
                return !this.panelService.expanded();
        }
    });
    protected readonly panelService = inject(PanelService);

    private readonly paginatorViewChild = viewChild<PaginatorComponent>('paginator');

    public constructor() {
        effect(() => {
            if (!this.paginatorViewChild()) {
                return;
            }
            this.paginator.emit(this.paginatorViewChild()!);
        });
    }
}
